<template>
    <WindowBase 
        class="window-asset" 
        :heading="heading" 
        :actions="actions">

        <Viewer 
            :asset="asset" 
            :fileKey="fileKey" 
            @delete="handleClose" />

        <Details
            :asset="asset" />

    </WindowBase>
</template>

<script>
import ASSETS from '@generio-ai/library-legacy/constants/assets'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import Details from '@generio-ai/library-legacy/components/details'
import { Viewer } from '@generio-ai/library-legacy/components/viewer'
import VERSION from '@/constants/version'
import WindowBase from '@/components/common/windows/WindowBase.vue'

export default {
    name: 'WindowAsset',
    components: {
        Details,
        Viewer,
        WindowBase
    },
    props: {
        asset: {
            type: Object,
            default: () => ({})
        },
        fileKey: {
            type: String,
            default: ASSETS.FILES.KEY.DEFAULT
        }
    },
    data() {
        return {
            mounted: false
        }
    },
    computed: {
        isLegacy() {
            return this.version < VERSION
        },

        isTypeModel() {
            return this.asset?.type === ASSETS.TYPES.MODEL
        },
        isTypeImage() {
            return this.asset?.type === ASSETS.TYPES.IMAGE
        },
        isTypeText() {
            return this.asset?.type === ASSETS.TYPES.TEXT
        },

        heading() {
            if (this.isTypeModel) return 'Viewing Model'
            if (this.isTypeImage) return 'Viewing Image'
            if (this.isTypeText) return 'Viewing Text'
            return 'Viewing Asset'
        },
        actions() {
            return [
                {
                    label: 'Close',
                    handler: this.handleClose
                },
                {
                    label: 'Open Flow',
                    variant: 'tonal',
                    color: 'color1',
                    disabled: this.isLegacy,
                    handler: this.handleOpen
                }
            ]
        },

        version() {
            return this.asset?.additional?.version ?? 0
        }
    },
    methods: {
        ...mapActions('flows', [
            'openAsset'
        ]),
        ...mapActions('windows', [
            'close'
        ]),
        async handleOpen() {
            this.openAsset({ asset: this.asset })
        },
        handleClose() {
            this.close()
        }
    },
    mounted() {
        this.mounted = true
    }
}
</script>